import { EditorObject } from 'utils/responsiveTypes'

const tableListsUsersTable: EditorObject = {
  x: 0,
  y: 20,
  id: 'bhqob6tt7iz0pd2zqvn5t2kpc',
  name: 'Section 22',
  type: 'LAYOUT_SECTION',
  width: 1512,
  height: 1031,
  hidden: false,
  mobile: {
    x: 0,
    y: 20,
    width: 1512,
    height: 880,
    pushGraph: {
      edges: [],
      nodeIds: ['7c0nkhswzjlbo72aabfiab81i'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'CENTER',
    },
  },
  shadow: {
    x: 0,
    y: 2,
    size: 4,
    color: '#00000020',
    enabled: true,
  },
  shared: {
    mobile: false,
    tablet: false,
    desktop: false,
  },
  tablet: {
    x: 0,
    y: 20,
    width: 1512,
    height: 810,
    pushGraph: {
      edges: [],
      nodeIds: ['7c0nkhswzjlbo72aabfiab81i'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'CENTER',
    },
  },
  actions: {},
  desktop: {
    x: 0,
    y: 20,
    width: 1512,
    height: 802,
    pushGraph: {
      edges: [],
      nodeIds: ['7c0nkhswzjlbo72aabfiab81i'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'CENTER',
    },
  },
  opacity: 1,
  children: [
    {
      x: 0,
      y: 35,
      id: '7c0nkhswzjlbo72aabfiab81i',
      name: 'Layout Helper',
      type: 'section',
      width: 1512,
      height: 1001,
      hidden: false,
      mobile: {
        x: 0,
        y: 36,
        width: 1512,
        height: 848,
        pushGraph: {
          edges: [],
          nodeIds: ['exzxdzipbwwzbggungbjmi1s1'],
        },
        positioning: 'fixed',
        responsivity: {
          verticalScaling: 'FIXED',
          horizontalScaling: 'SCALES_WITH_PARENT',
          verticalPositioning: 'TOP',
          horizontalPositioning: 'CENTER',
        },
      },
      shadow: {
        x: 0,
        y: 2,
        size: 4,
        color: 'rgba(0, 0, 0, 0.2)',
        enabled: false,
      },
      shared: {
        mobile: false,
        tablet: false,
        desktop: false,
      },
      tablet: {
        x: 0,
        y: 36,
        width: 1512,
        height: 778,
        pushGraph: {
          edges: [],
          nodeIds: ['exzxdzipbwwzbggungbjmi1s1'],
        },
        positioning: 'fixed',
        responsivity: {
          verticalScaling: 'FIXED',
          horizontalScaling: 'SCALES_WITH_PARENT',
          verticalPositioning: 'TOP',
          horizontalPositioning: 'CENTER',
        },
      },
      actions: {},
      desktop: {
        x: 0,
        y: 35,
        width: 1512,
        height: 772,
        pushGraph: {
          edges: [],
          nodeIds: ['exzxdzipbwwzbggungbjmi1s1'],
        },
        positioning: 'fixed',
        responsivity: {
          verticalScaling: 'FIXED',
          horizontalScaling: 'SCALES_WITH_PARENT',
          verticalPositioning: 'TOP',
          horizontalPositioning: 'CENTER',
        },
      },
      opacity: 1,
      purpose: 'layout_helper',
      children: [
        {
          x: 16,
          y: 35,
          id: 'exzxdzipbwwzbggungbjmi1s1',
          name: 'Container',
          type: 'section',
          width: 1480,
          height: 1001,
          hidden: false,
          mobile: {
            x: 62.030769230769344,
            y: 36,
            width: 1387.9384615384615,
            height: 848,
            pushGraph: {
              edges: [
                {
                  distance: 9,
                  endNodeId: '46vlmpeu65hn8c9882woh13dh',
                  startNodeId: '11gcq52q0smh4xqa7x52owpx4',
                },
                {
                  distance: 14,
                  endNodeId: 'cmkogwg9omsrc7tvu7ecum55e',
                  startNodeId: '46vlmpeu65hn8c9882woh13dh',
                },
              ],
              nodeIds: [
                '11gcq52q0smh4xqa7x52owpx4',
                '46vlmpeu65hn8c9882woh13dh',
                'cmkogwg9omsrc7tvu7ecum55e',
              ],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          shadow: {
            x: 0,
            y: 2,
            size: 4,
            color: '#00000020',
            enabled: true,
          },
          shared: {
            mobile: false,
            tablet: false,
            desktop: false,
          },
          tablet: {
            x: 192.67266187050353,
            y: 36,
            width: 1127.6546762589928,
            height: 778,
            pushGraph: {
              edges: [
                {
                  distance: 28,
                  endNodeId: 'c7noljmbsnfa5hentrxad86t4',
                  startNodeId: '11gcq52q0smh4xqa7x52owpx4',
                },
                {
                  distance: 28,
                  endNodeId: '9xs63r2ltyytfjmpe09dxf6b1',
                  startNodeId: '11gcq52q0smh4xqa7x52owpx4',
                },
                {
                  distance: 28,
                  endNodeId: 'benkmxwg8vlb10252hh7t59et',
                  startNodeId: '11gcq52q0smh4xqa7x52owpx4',
                },
                {
                  distance: 28,
                  endNodeId: '1e6b56wcgjegkdurw99fz2ntk',
                  startNodeId: '11gcq52q0smh4xqa7x52owpx4',
                },
                {
                  distance: 12,
                  endNodeId: '46vlmpeu65hn8c9882woh13dh',
                  startNodeId: 'c7noljmbsnfa5hentrxad86t4',
                },
                {
                  distance: 12,
                  endNodeId: '46vlmpeu65hn8c9882woh13dh',
                  startNodeId: '9xs63r2ltyytfjmpe09dxf6b1',
                },
                {
                  distance: 12,
                  endNodeId: '46vlmpeu65hn8c9882woh13dh',
                  startNodeId: 'benkmxwg8vlb10252hh7t59et',
                },
                {
                  distance: 12,
                  endNodeId: '46vlmpeu65hn8c9882woh13dh',
                  startNodeId: '1e6b56wcgjegkdurw99fz2ntk',
                },
                {
                  distance: 14,
                  endNodeId: 'cmkogwg9omsrc7tvu7ecum55e',
                  startNodeId: '46vlmpeu65hn8c9882woh13dh',
                },
              ],
              nodeIds: [
                '11gcq52q0smh4xqa7x52owpx4',
                'c7noljmbsnfa5hentrxad86t4',
                '9xs63r2ltyytfjmpe09dxf6b1',
                'benkmxwg8vlb10252hh7t59et',
                '1e6b56wcgjegkdurw99fz2ntk',
                '46vlmpeu65hn8c9882woh13dh',
                'cmkogwg9omsrc7tvu7ecum55e',
              ],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          actions: {},
          desktop: {
            x: 261,
            y: 35,
            width: 989.9999999999998,
            height: 772,
            pushGraph: {
              edges: [
                {
                  distance: 28,
                  endNodeId: 'c7noljmbsnfa5hentrxad86t4',
                  startNodeId: '11gcq52q0smh4xqa7x52owpx4',
                },
                {
                  distance: 28,
                  endNodeId: '9xs63r2ltyytfjmpe09dxf6b1',
                  startNodeId: '11gcq52q0smh4xqa7x52owpx4',
                },
                {
                  distance: 28,
                  endNodeId: 'benkmxwg8vlb10252hh7t59et',
                  startNodeId: '11gcq52q0smh4xqa7x52owpx4',
                },
                {
                  distance: 28,
                  endNodeId: '1e6b56wcgjegkdurw99fz2ntk',
                  startNodeId: '11gcq52q0smh4xqa7x52owpx4',
                },
                {
                  distance: 12,
                  endNodeId: '46vlmpeu65hn8c9882woh13dh',
                  startNodeId: 'c7noljmbsnfa5hentrxad86t4',
                },
                {
                  distance: 12,
                  endNodeId: '46vlmpeu65hn8c9882woh13dh',
                  startNodeId: '9xs63r2ltyytfjmpe09dxf6b1',
                },
                {
                  distance: 12,
                  endNodeId: '46vlmpeu65hn8c9882woh13dh',
                  startNodeId: 'benkmxwg8vlb10252hh7t59et',
                },
                {
                  distance: 12,
                  endNodeId: '46vlmpeu65hn8c9882woh13dh',
                  startNodeId: '1e6b56wcgjegkdurw99fz2ntk',
                },
                {
                  distance: 14,
                  endNodeId: 'cmkogwg9omsrc7tvu7ecum55e',
                  startNodeId: '46vlmpeu65hn8c9882woh13dh',
                },
              ],
              nodeIds: [
                '11gcq52q0smh4xqa7x52owpx4',
                'c7noljmbsnfa5hentrxad86t4',
                '9xs63r2ltyytfjmpe09dxf6b1',
                'benkmxwg8vlb10252hh7t59et',
                '1e6b56wcgjegkdurw99fz2ntk',
                '46vlmpeu65hn8c9882woh13dh',
                'cmkogwg9omsrc7tvu7ecum55e',
              ],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          opacity: 1,
          purpose: 'container',
          children: [
            {
              x: 40.51291866028714,
              y: 174,
              id: 'cmkogwg9omsrc7tvu7ecum55e',
              name: 'List 29',
              type: 'list',
              width: 1435.3148325358845,
              height: 618,
              hidden: false,
              mobile: {
                x: 85.29230769230782,
                y: 125,
                width: 1345.2923076923082,
                height: 750,
                pushGraph: {
                  edges: [
                    {
                      distance: 9.5,
                      endNodeId: '6go8my2ejb7uf6g0o99oi75pa',
                      startNodeId: '0648cv98qesfrqz28awfdcq23',
                    },
                    {
                      distance: 45,
                      endNodeId: '1zrbytfjk760ggtfzmg3ek78o',
                      startNodeId: 'buffer_1zrbytfjk760ggtfzmg3ek78o',
                    },
                    {
                      distance: 9.5,
                      endNodeId: '4174xsoi603nmacf2vrwgrnfv',
                      startNodeId: '6go8my2ejb7uf6g0o99oi75pa',
                    },
                    {
                      distance: 24,
                      endNodeId: '3addwp7zpmuwgsbxarvrkq7td',
                      startNodeId: '4174xsoi603nmacf2vrwgrnfv',
                    },
                    {
                      distance: 9,
                      endNodeId: 'cvpy7ynih2ecm0o7z12njuv8k',
                      startNodeId: '1zrbytfjk760ggtfzmg3ek78o',
                    },
                    {
                      distance: 9,
                      endNodeId: 'cvpy7ynih2ecm0o7z12njuv8k',
                      startNodeId: '3addwp7zpmuwgsbxarvrkq7td',
                    },
                  ],
                  nodeIds: [
                    '0648cv98qesfrqz28awfdcq23',
                    '6go8my2ejb7uf6g0o99oi75pa',
                    'buffer_1zrbytfjk760ggtfzmg3ek78o',
                    '1zrbytfjk760ggtfzmg3ek78o',
                    '4174xsoi603nmacf2vrwgrnfv',
                    '3addwp7zpmuwgsbxarvrkq7td',
                    'cvpy7ynih2ecm0o7z12njuv8k',
                  ],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              shared: {
                mobile: false,
                tablet: true,
                desktop: true,
              },
              tablet: {
                x: 211.34976143538807,
                y: 175,
                width: 1093.6077586574213,
                height: 618,
                pushGraph: {
                  edges: [
                    {
                      distance: 13,
                      endNodeId: 'cvpy7ynih2ecm0o7z12njuv8k',
                      startNodeId: '0648cv98qesfrqz28awfdcq23',
                    },
                    {
                      distance: 13,
                      endNodeId: 'cvpy7ynih2ecm0o7z12njuv8k',
                      startNodeId: '6go8my2ejb7uf6g0o99oi75pa',
                    },
                    {
                      distance: 13,
                      endNodeId: 'cvpy7ynih2ecm0o7z12njuv8k',
                      startNodeId: '4174xsoi603nmacf2vrwgrnfv',
                    },
                    {
                      distance: 13,
                      endNodeId: 'cvpy7ynih2ecm0o7z12njuv8k',
                      startNodeId: '3addwp7zpmuwgsbxarvrkq7td',
                    },
                    {
                      distance: 13,
                      endNodeId: 'cvpy7ynih2ecm0o7z12njuv8k',
                      startNodeId: '1zrbytfjk760ggtfzmg3ek78o',
                    },
                  ],
                  nodeIds: [
                    '0648cv98qesfrqz28awfdcq23',
                    '6go8my2ejb7uf6g0o99oi75pa',
                    '4174xsoi603nmacf2vrwgrnfv',
                    '3addwp7zpmuwgsbxarvrkq7td',
                    '1zrbytfjk760ggtfzmg3ek78o',
                    'cvpy7ynih2ecm0o7z12njuv8k',
                  ],
                },
              },
              actions: {},
              desktop: {
                x: 277.39715504978665,
                y: 174,
                width: 960.1092460881929,
                height: 618,
                pushGraph: {
                  edges: [
                    {
                      distance: 13,
                      endNodeId: 'cvpy7ynih2ecm0o7z12njuv8k',
                      startNodeId: '0648cv98qesfrqz28awfdcq23',
                    },
                    {
                      distance: 13,
                      endNodeId: 'cvpy7ynih2ecm0o7z12njuv8k',
                      startNodeId: '6go8my2ejb7uf6g0o99oi75pa',
                    },
                    {
                      distance: 13,
                      endNodeId: 'cvpy7ynih2ecm0o7z12njuv8k',
                      startNodeId: '4174xsoi603nmacf2vrwgrnfv',
                    },
                    {
                      distance: 13,
                      endNodeId: 'cvpy7ynih2ecm0o7z12njuv8k',
                      startNodeId: '3addwp7zpmuwgsbxarvrkq7td',
                    },
                    {
                      distance: 13,
                      endNodeId: 'cvpy7ynih2ecm0o7z12njuv8k',
                      startNodeId: '1zrbytfjk760ggtfzmg3ek78o',
                    },
                  ],
                  nodeIds: [
                    '0648cv98qesfrqz28awfdcq23',
                    '6go8my2ejb7uf6g0o99oi75pa',
                    '4174xsoi603nmacf2vrwgrnfv',
                    '3addwp7zpmuwgsbxarvrkq7td',
                    '1zrbytfjk760ggtfzmg3ek78o',
                    'cvpy7ynih2ecm0o7z12njuv8k',
                  ],
                },
              },
              masonry: true,
              opacity: 1,
              children: [
                {
                  x: 42.446536257122126,
                  y: 174,
                  id: '0648cv98qesfrqz28awfdcq23',
                  name: null,
                  text: 'Jamie Smith',
                  type: 'label',
                  color: '@text',
                  width: 240.87803472703536,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 87.10230239475894,
                    y: 125,
                    width: 946.1228046287897,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 212.08821570165753,
                    y: 175,
                    width: 214.03034747573213,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 279.13420706229306,
                    y: 174,
                    width: 198.28833618206738,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  fontWeight: 500,
                  layoutText: ['Jamie Smith'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'left',
                },
                {
                  x: 366.3750317006785,
                  y: 174,
                  id: '6go8my2ejb7uf6g0o99oi75pa',
                  name: null,
                  text: 'Director of Engineering',
                  type: 'label',
                  color: '@text',
                  width: 287.8237340862586,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 87.10230239475894,
                    y: 153.5,
                    width: 977.07074683627,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 459.6271899858492,
                    y: 175,
                    width: 219.2956275523518,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 493.865966244823,
                    y: 174,
                    width: 223.43710077101207,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  fontWeight: 500,
                  layoutText: ['Director of Engineering'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'left',
                },
                {
                  x: 694.7730366713462,
                  y: 174,
                  id: '4174xsoi603nmacf2vrwgrnfv',
                  name: null,
                  text: 'jamie@adalo.com',
                  type: 'label',
                  color: '@text',
                  width: 347.4171944477332,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 87.10230239475894,
                    y: 182,
                    width: 1012.4398236448264,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 709.4826851875166,
                    y: 175,
                    width: 328.5818010542903,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 747.288132487182,
                    y: 174,
                    width: 248.58586535995676,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  fontWeight: 500,
                  layoutText: ['jamie@adalo.com'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'left',
                },
                {
                  x: 1166.4489357025689,
                  y: 174,
                  id: '3addwp7zpmuwgsbxarvrkq7td',
                  name: null,
                  text: 'Admin',
                  type: 'label',
                  color: '@text',
                  width: 163.56502950276513,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 87.10230239475894,
                    y: 225,
                    width: 269.68921066521284,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 1069.2110709793915,
                    y: 175,
                    width: 124.62174429186473,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 1030.2539963824433,
                    y: 174,
                    width: 109.36771681521611,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  fontWeight: 500,
                  layoutText: ['Admin'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'left',
                },
                {
                  x: 1388.3394796016655,
                  y: 174,
                  id: '1zrbytfjk760ggtfzmg3ek78o',
                  name: null,
                  text: 'Edit',
                  type: 'label',
                  color: '@secondaryDark',
                  width: 87.48827159450525,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 1241.0184332737938,
                    y: 170,
                    width: 185.68765324490164,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 1238.2715768016874,
                    y: 175,
                    width: 66.65814229565035,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 1178.6210540774946,
                    y: 174,
                    width: 58.49901131976583,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  fontWeight: 500,
                  layoutText: ['Edit'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'left',
                },
                {
                  x: 41.10283008679153,
                  y: 206,
                  id: 'cvpy7ynih2ecm0o7z12njuv8k',
                  name: 'Line',
                  type: 'line',
                  width: 1429.1408731744034,
                  height: 1,
                  hidden: false,
                  mobile: {
                    x: 82.68116779368732,
                    y: 253,
                    width: 1337.7709293378682,
                    height: 1,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 211.79922053536924,
                    y: 207,
                    width: 1088.875959581468,
                    height: 1,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 277.7915991802955,
                    y: 206,
                    width: 955.5946939363611,
                    height: 1,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  borderColor: '#e0e0e0',
                  borderStyle: 'solid',
                  borderWidth: 1,
                  positioning: 'fixed',
                  borderRadius: 0,
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  borderPosition: 'center',
                  backgroundColor: 'rgba(255, 255, 255, 0)',
                  backgroundStyle: 'color',
                },
              ],
              pushGraph: {
                edges: [
                  {
                    distance: 13,
                    endNodeId: 'cvpy7ynih2ecm0o7z12njuv8k',
                    startNodeId: '0648cv98qesfrqz28awfdcq23',
                  },
                  {
                    distance: 13,
                    endNodeId: 'cvpy7ynih2ecm0o7z12njuv8k',
                    startNodeId: '6go8my2ejb7uf6g0o99oi75pa',
                  },
                  {
                    distance: 13,
                    endNodeId: 'cvpy7ynih2ecm0o7z12njuv8k',
                    startNodeId: '4174xsoi603nmacf2vrwgrnfv',
                  },
                  {
                    distance: 13,
                    endNodeId: 'cvpy7ynih2ecm0o7z12njuv8k',
                    startNodeId: '3addwp7zpmuwgsbxarvrkq7td',
                  },
                  {
                    distance: 13,
                    endNodeId: 'cvpy7ynih2ecm0o7z12njuv8k',
                    startNodeId: '1zrbytfjk760ggtfzmg3ek78o',
                  },
                ],
                nodeIds: [
                  '0648cv98qesfrqz28awfdcq23',
                  '6go8my2ejb7uf6g0o99oi75pa',
                  '4174xsoi603nmacf2vrwgrnfv',
                  '3addwp7zpmuwgsbxarvrkq7td',
                  '1zrbytfjk760ggtfzmg3ek78o',
                  'cvpy7ynih2ecm0o7z12njuv8k',
                ],
              },
              rowMargin: 25,
              columnCount: 1,
              positioning: 'fixed',
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              backgroundColor: 'rgba(0, 0, 0, 0)',
            },
            {
              x: 40,
              y: 128,
              id: 'c7noljmbsnfa5hentrxad86t4',
              name: null,
              text: 'Name',
              type: 'label',
              color: '@text',
              width: 244.00000000000205,
              height: 19,
              hidden: false,
              mobile: {
                y: 128,
              },
              shared: {
                mobile: true,
                tablet: true,
                desktop: true,
              },
              tablet: {
                x: 210.95895391794664,
                y: 129,
                width: 185.91063581567334,
                height: 19,
              },
              actions: {},
              desktop: {
                x: 277.05405405405406,
                y: 128,
                width: 163.2162162162175,
                height: 19,
              },
              opacity: 1,
              children: [],
              fontSize: 16,
              autoWidth: false,
              fontStyle: 'normal',
              // maxLength: null,
              multiline: false,
              fontFamily: '@body',
              // fontWeight: '700',
              layoutText: ['Name'],
              selectable: false,
              positioning: 'fixedTop',
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              textAlignment: 'left',
              deviceVisibility: {
                mobile: false,
                tablet: true,
                desktop: true,
              },
            },
            {
              x: 364.04697986577116,
              y: 128,
              id: '9xs63r2ltyytfjmpe09dxf6b1',
              name: null,
              text: 'Title',
              type: 'label',
              color: '@text',
              width: 218.17449664429637,
              height: 19,
              hidden: false,
              mobile: {
                y: 128,
              },
              shared: {
                mobile: true,
                tablet: true,
                desktop: true,
              },
              tablet: {
                x: 457.8596918728389,
                y: 129,
                width: 166.2334401225628,
                height: 19,
              },
              actions: {},
              desktop: {
                x: 493.8152095048063,
                y: 128,
                width: 145.94104843098194,
                height: 19,
              },
              opacity: 1,
              children: [],
              fontSize: 16,
              autoWidth: false,
              fontStyle: 'normal',
              // maxLength: null,
              multiline: false,
              fontFamily: '@body',
              // fontWeight: '700',
              layoutText: ['Title'],
              selectable: false,
              positioning: 'fixedTop',
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              textAlignment: 'left',
              deviceVisibility: {
                mobile: false,
                tablet: true,
                desktop: true,
              },
            },
            {
              x: 739.3607655502392,
              y: 128,
              id: 'benkmxwg8vlb10252hh7t59et',
              name: null,
              text: 'Email',
              type: 'label',
              color: '@text',
              width: 364.6162679425838,
              height: 19,
              hidden: false,
              mobile: {
                y: 128,
              },
              shared: {
                mobile: true,
                tablet: true,
                desktop: true,
              },
              tablet: {
                x: 743.8220874752415,
                y: 129,
                width: 277.8116483686192,
                height: 19,
              },
              actions: {},
              desktop: {
                x: 744.8697012802274,
                y: 128,
                width: 243.89871977240387,
                height: 19,
              },
              opacity: 1,
              children: [],
              fontSize: 16,
              autoWidth: false,
              fontStyle: 'normal',
              // maxLength: null,
              multiline: false,
              fontFamily: '@body',
              // fontWeight: '700',
              layoutText: ['Email'],
              selectable: false,
              positioning: 'fixedTop',
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              textAlignment: 'left',
              deviceVisibility: {
                mobile: false,
                tablet: true,
                desktop: true,
              },
            },
            {
              x: 1165.7114093959742,
              y: 128,
              id: '1e6b56wcgjegkdurw99fz2ntk',
              name: null,
              text: 'Role',
              type: 'label',
              color: '@text',
              width: 164.89932885906023,
              height: 19,
              hidden: false,
              mobile: {
                y: 128,
              },
              shared: {
                mobile: true,
                tablet: true,
                desktop: true,
              },
              tablet: {
                x: 1068.6709369743464,
                y: 129,
                width: 125.64155358100595,
                height: 19,
              },
              actions: {},
              desktop: {
                x: 1030.0637130419013,
                y: 128,
                width: 110.30428079085777,
                height: 19,
              },
              opacity: 1,
              children: [],
              fontSize: 16,
              autoWidth: false,
              fontStyle: 'normal',
              // maxLength: null,
              multiline: false,
              fontFamily: '@body',
              // fontWeight: '700',
              layoutText: ['Role'],
              selectable: false,
              positioning: 'fixedTop',
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              textAlignment: 'left',
              deviceVisibility: {
                mobile: false,
                tablet: true,
                desktop: true,
              },
            },
            {
              x: 41.18075292175445,
              y: 159,
              id: '46vlmpeu65hn8c9882woh13dh',
              name: 'Line  12',
              type: 'line',
              width: 1429.716172765447,
              height: 1,
              hidden: false,
              mobile: {
                x: 85.64518508928285,
                y: 110,
                width: 1340.7824765302244,
                height: 1,
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              shared: {
                mobile: false,
                tablet: true,
                desktop: true,
              },
              tablet: {
                x: 211.85860361640806,
                y: 160,
                width: 1089.341978339234,
                height: 1,
              },
              actions: {},
              desktop: {
                x: 277.84388202198437,
                y: 159,
                width: 956.3641966471569,
                height: 1,
              },
              opacity: 1,
              children: [],
              borderColor: '#e0e0e0',
              borderStyle: 'solid',
              borderWidth: 1,
              positioning: 'fixed',
              borderRadius: 0,
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              borderPosition: 'center',
              backgroundColor: 'rgba(255, 255, 255, 0)',
              backgroundStyle: 'color',
            },
            {
              x: 41.10291262135934,
              y: 58,
              id: '11gcq52q0smh4xqa7x52owpx4',
              name: null,
              text: 'Table',
              type: 'label',
              color: '@text',
              width: 1429.7941747572806,
              height: 42,
              hidden: false,
              mobile: {
                x: 85.57218674686658,
                y: 59,
                width: 1340.8556265062664,
                height: 42,
              },
              shared: {
                mobile: true,
                tablet: true,
                desktop: true,
              },
              tablet: {
                x: 211.79929484698783,
                y: 59,
                width: 1089.4014103060238,
                height: 42,
              },
              actions: {},
              desktop: {
                x: 277.7918131723958,
                y: 58,
                width: 956.4163736552077,
                height: 42,
              },
              opacity: 1,
              children: [],
              fontSize: 36,
              autoWidth: false,
              fontStyle: 'normal',
              // maxLength: null,
              multiline: true,
              fontFamily: '@body',
              // fontWeight: '500',
              layoutText: ['Table'],
              selectable: false,
              positioning: 'fixedTop',
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              textAlignment: 'left',
              inResponsiveApp: true,
              calculatedFontFamily:
                'Inter, -apple-system, "SF Pro Text", sans-serif',
            },
          ],
          pushGraph: {
            edges: [
              {
                distance: 28,
                endNodeId: 'c7noljmbsnfa5hentrxad86t4',
                startNodeId: '11gcq52q0smh4xqa7x52owpx4',
              },
              {
                distance: 28,
                endNodeId: '9xs63r2ltyytfjmpe09dxf6b1',
                startNodeId: '11gcq52q0smh4xqa7x52owpx4',
              },
              {
                distance: 28,
                endNodeId: 'benkmxwg8vlb10252hh7t59et',
                startNodeId: '11gcq52q0smh4xqa7x52owpx4',
              },
              {
                distance: 28,
                endNodeId: '1e6b56wcgjegkdurw99fz2ntk',
                startNodeId: '11gcq52q0smh4xqa7x52owpx4',
              },
              {
                distance: 12,
                endNodeId: '46vlmpeu65hn8c9882woh13dh',
                startNodeId: 'c7noljmbsnfa5hentrxad86t4',
              },
              {
                distance: 12,
                endNodeId: '46vlmpeu65hn8c9882woh13dh',
                startNodeId: '9xs63r2ltyytfjmpe09dxf6b1',
              },
              {
                distance: 12,
                endNodeId: '46vlmpeu65hn8c9882woh13dh',
                startNodeId: 'benkmxwg8vlb10252hh7t59et',
              },
              {
                distance: 12,
                endNodeId: '46vlmpeu65hn8c9882woh13dh',
                startNodeId: '1e6b56wcgjegkdurw99fz2ntk',
              },
              {
                distance: 14,
                endNodeId: 'cmkogwg9omsrc7tvu7ecum55e',
                startNodeId: '46vlmpeu65hn8c9882woh13dh',
              },
            ],
            nodeIds: [
              '11gcq52q0smh4xqa7x52owpx4',
              'c7noljmbsnfa5hentrxad86t4',
              '9xs63r2ltyytfjmpe09dxf6b1',
              'benkmxwg8vlb10252hh7t59et',
              '1e6b56wcgjegkdurw99fz2ntk',
              '46vlmpeu65hn8c9882woh13dh',
              'cmkogwg9omsrc7tvu7ecum55e',
            ],
          },
          borderColor: '#e0e0e0',
          borderStyle: 'none',
          borderWidth: 1,
          positioning: 'fixed',
          borderRadius: 10,
          responsivity: {
            verticalScaling: 'FIXED',
            horizontalScaling: 'SCALES_WITH_PARENT',
            verticalPositioning: 'TOP',
            horizontalPositioning: 'LEFT_AND_RIGHT',
          },
          initialDevice: 'desktop',
          borderPosition: 'center',
          backgroundColor: '#f5f5f5',
          backgroundStyle: 'none',
        },
      ],
      pushGraph: {
        edges: [],
        nodeIds: ['exzxdzipbwwzbggungbjmi1s1'],
      },
      borderColor: '#BDBDBD',
      borderStyle: 'none',
      borderWidth: 1,
      positioning: 'fixed',
      borderRadius: 0,
      responsivity: {
        verticalScaling: 'FIXED',
        horizontalScaling: 'SCALES_WITH_PARENT',
        verticalPositioning: 'TOP',
        horizontalPositioning: 'CENTER',
      },
      initialDevice: 'desktop',
      borderPosition: 'center',
      backgroundColor: '#e0e0e0',
      backgroundStyle: 'none',
    },
  ],
  pushGraph: {
    edges: [],
    nodeIds: ['7c0nkhswzjlbo72aabfiab81i'],
  },
  borderColor: '#e0e0e0',
  borderStyle: 'none',
  borderWidth: 1,
  imageResize: 'cover',
  positioning: 'fixedTop',
  borderRadius: 0,
  responsivity: {
    verticalScaling: 'FIXED',
    horizontalScaling: 'SCALES_WITH_PARENT',
    verticalPositioning: 'TOP',
    horizontalPositioning: 'CENTER',
  },
  initialDevice: 'desktop',
  snappingRules: {
    lock: {
      left: 0,
      right: 0,
    },
    snap: true,
    snapType: 'screenEdge',
  },
  borderPosition: 'center',
  backgroundColor: '@background',
  backgroundStyle: 'none',
}

export default tableListsUsersTable
